import type { SyntheticEvent } from "react";
import { Sparkles } from "lucide-react";

export function ProjectDescriptionStart({
  busy,
  description,
  error,
  onChange,
  onSubmit,
}: {
  busy: boolean;
  description: string;
  error: string;
  onChange: (description: string) => void;
  onSubmit: (event: SyntheticEvent<HTMLFormElement>) => void;
}) {
  return (
    <main className="grid min-h-[calc(100vh-73px)] place-items-center bg-stone-50 px-4 py-12">
      <form
        className="w-full max-w-2xl rounded-3xl border border-stone-200 bg-white p-6 shadow-xl shadow-stone-900/5 sm:p-10"
        onSubmit={onSubmit}
      >
        <span className="grid h-12 w-12 place-items-center rounded-2xl bg-emerald-950 text-white">
          <Sparkles size={22} />
        </span>
        <h1 className="mt-5 text-3xl font-black tracking-tight text-emerald-950">
          What are you planning?
        </h1>
        <p className="mt-3 text-stone-600">
          Describe the whole project naturally. Afterward, choose the contractor you want to work
          with. The project guide will classify the work and ask only for missing details.
        </p>
        <label
          className="mt-7 block text-sm font-bold text-stone-700"
          htmlFor="project-description"
        >
          Project description
        </label>
        <textarea
          className="mt-2 min-h-36 w-full rounded-2xl border border-stone-300 px-4 py-3 leading-7 outline-none focus:border-emerald-700 focus:ring-4 focus:ring-emerald-100"
          id="project-description"
          maxLength={8000}
          onChange={(event) => onChange(event.target.value)}
          placeholder="For example: Replace three basement windows and the rear exterior door, including new casing."
          value={description}
        />
        {error ? <p className="mt-3 text-sm text-red-700">{error}</p> : null}
        <button
          className="mt-5 inline-flex min-h-12 items-center rounded-xl bg-emerald-800 px-5 font-bold text-white disabled:opacity-50"
          disabled={!description.trim() || busy}
          type="submit"
        >
          {busy ? "Saving…" : "Choose a contractor"}
        </button>
      </form>
    </main>
  );
}
